<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import { computed } from "vue";
import Header from "./views/Header/Header.vue";
import { useAuthStore } from "./stores/auth";

const authStore = useAuthStore();
const route = useRoute();

// Only show header if authenticated AND not on login page
const shouldShowHeader = computed(() => {
  return authStore.isAuthenticated && route.path !== "/login";
});
</script>

<template>
  <div class="flex flex-col h-full overflow-hidden">
    <Header v-if="shouldShowHeader" class="fixed top-0 left-0 right-0 z-[1000]" />
    <main class="flex-1 flex overflow-hidden" :class="{ 'pt-[72px] md:pt-16': shouldShowHeader }">
      <div class="w-full h-full p-4 overflow-hidden">
        <RouterView />
      </div>
    </main>
  </div>
</template>
